<div class="modal-content">
  <form method="post" [formGroup]="addExamSubjectform">
    <div class="modal-header">
      <h4>Vizsgatárgy hozzáadása</h4>
    </div>
    <div class="modal-body">
      <div *ngIf="!isLoading">
        <div class="form-group mb-3">
          <label>Vizsgatárgy<span class="required-label" *ngIf="examSubject.errors?.['required']">*</span></label>
          <ng-select
            formControlName="examSubject"
            placeholder="Kérem válasszon vizsgatárgyat!"
            notFoundText="Nincs találat!"
            id="exam-subject-select"
            (change)="onExamSubjectChange()"
          >
            <ng-option *ngFor="let option of selectList.items" [value]="option.value">
              <div class="ng-option-div" [title]="option.text">{{ option.text }}</div>
            </ng-option>
          </ng-select>
          <div *ngIf="examSubject.invalid && (examSubject.dirty || examSubject.touched)" class="alert alert-danger">
            <div *ngIf="examSubject.errors?.['required']">Vizsga kiválasztása kötelező.</div>
          </div>
        </div>
        <div class="form-group mb-3">
          <label
            >Bruttó időkeret (perc)<span class="required-label" *ngIf="grossTimeLimitMinutes.errors?.['required']"
              >*</span
            ></label
          >
          <input type="number" formControlName="grossTimeLimitMinutes" class="form-control" />
          <div
            *ngIf="grossTimeLimitMinutes.invalid && (grossTimeLimitMinutes.dirty || grossTimeLimitMinutes.touched)"
            class="alert alert-danger"
          >
            <div *ngIf="grossTimeLimitMinutes.errors?.['required']">Bruttó időkeret megadása kötelező.</div>
            <div *ngIf="grossTimeLimitMinutes.errors?.['min']">0-nál kisebb érték megadása tilos.</div>
            <div *ngIf="grossTimeLimitMinutes.errors?.['serverError']">{{grossTimeLimitMinutes.errors?.['serverError']}}</div>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>SNI szorzó</label>
          <input type="number" formControlName="timeLimitMultiplier" class="form-control" />
          <div *ngIf="timeLimitMultiplier.invalid && (timeLimitMultiplier.dirty || timeLimitMultiplier.touched)" class="alert alert-danger">
            <div *ngIf="timeLimitMultiplier.errors?.['min']">0-nál kisebb érték megadása tilos.</div>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Kezdés időpontja<span class="required-label" *ngIf="startDateAtUtc.errors?.['required']">*</span></label>
          <input formControlName="startDateAtUtc" type="text" class="form-control" appDateTimePicker />

          <div *ngIf="startDateAtUtc.invalid && (startDateAtUtc.dirty || startDateAtUtc.touched)" class="alert alert-danger">
            <div *ngIf="startDateAtUtc.errors?.['required']">Kezdő időpont megadása kötelező.</div>
            <div *ngIf="startDateAtUtc.errors?.['serverError']">{{startDateAtUtc.errors?.['serverError']}}</div>
          </div>
        </div>
      </div>
      <div class="mt-5 mb-5">
        <app-loader *ngIf="isLoading"></app-loader>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-dark" (click)="close()">Mégse</button>
      <button
        type="button"
        class="btn btn-primary text-white"
        (click)="confirm()"
        [disabled]="isLoading || addExamSubjectform.invalid || isInProgress"
      >
        Hozzáadás
      </button>
    </div>
  </form>
</div>
